import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { Page, ProdutoSimplificado } from '../../../models/cadastro.model';
import { CadastroService } from '../../../services/cadastro.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ModalStateService } from '../../../services/modaState.service';

@Component({
  selector: 'app-produto-modal',
  imports: [CommonModule, FormsModule],
  standalone: true,
  templateUrl: './produto-modal.html',
  styleUrl: './produto-modal.css'
})
export class ProdutoModal implements OnInit {

  ngOnInit(): void {
    this.resetForm();
  }

  @Input() isOpen = false;
  @Output() closeModal = new EventEmitter<void>();

  modalStateService = inject(ModalStateService);
  cadastroService = inject(CadastroService);
  selectedProduto: ProdutoSimplificado = this.getNewProduto();
  isProdutoSelected = false;


  termo: string = '';
  produtoPage: Page<ProdutoSimplificado> | undefined;
  page = 0;
  size = 5;

  // Pagination
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  search() {
    this.cadastroService.getProdutoSimplificado(this.termo, this.page, this.size).subscribe(response => {
      this.produtoPage = response;
      this.updatePageNumbers();
    });
  }

  selectProduto(produto: ProdutoSimplificado): void {
    this.isProdutoSelected = true;
    this.selectedProduto = produto;
  }

  inserirProduto(): void {
    this.isOpen = false;
    this.modalStateService.close(this.selectedProduto);
    this.onClose();
  }

  onPageChange(page: number) {
    this.setPage(page);
  }
  
  setPage(page: number): void {
    if (page < 0 || (this.produtoPage && page >= this.produtoPage.totalPages)) {
      return;
    }
    this.page = page;
    this.search();
  }

  updatePageNumbers(): void {
    if (!this.produtoPage) {
      return;
    }

    const totalPages = this.produtoPage.totalPages;
    const currentPage = this.page;
    const maxPages = this.maxPagesToShow;

    let startPage: number, endPage: number;

    if (totalPages <= maxPages) {
      startPage = 0;
      endPage = totalPages - 1;
    } else {
      const maxPagesBeforeCurrent = Math.floor(maxPages / 2);
      const maxPagesAfterCurrent = Math.ceil(maxPages / 2) - 1;

      if (currentPage <= maxPagesBeforeCurrent) {
        startPage = 0;
        endPage = maxPages - 1;
      } else if (currentPage + maxPagesAfterCurrent >= totalPages) {
        startPage = totalPages - maxPages;
        endPage = totalPages - 1;
      } else {
        startPage = currentPage - maxPagesBeforeCurrent;
        endPage = currentPage + maxPagesAfterCurrent;
      }
    }

    this.pages = Array.from(Array((endPage - startPage) + 1).keys()).map(i => startPage + i);
  }

  public onClose(): void {
    this.closeModal.emit();
  }

  public resetForm(): void {
    this.termo = '';
  }

  private getNewProduto(): ProdutoSimplificado {
    return {
      id: 0,
      nomeProduto: '',
      descricao: '',
      tipo: '',
      precoUnitario: 0
    };
  }
}
